import * as Yup from "yup"

const salonSchema = Yup.object({
  people: Yup.number().typeError("Must be a number").required("No. of People is required").min(1, "At least 1 person"),
  service: Yup.array().min(1, "Please select at least one service").required("Service is required"),
  otherService: Yup.string().when("service", {
    is: (val: any) => Array.isArray(val) && val.includes("Others"),
    then: (schema) => schema.required("Please specify other service"),
    otherwise: (schema) => schema,
  }),
  supplies: Yup.string().required("Please select Include Supplies?"),
  allergies: Yup.string().required("Please select allergies"),
  allergyDetails: Yup.string().when("allergies", {
    is: "Yes",
    then: (schema) => schema.required("Please specify allergies"),
    otherwise: (schema) => schema,
  }),
})

export default salonSchema
